import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogPatientSummarySheet } from '../dialog-patient-summary-sheet/dialog-patient-summary-sheet.component';
import { PatientDto } from 'src/app/core/models/patient/patient.dto';
import { CatalogPatientService } from 'src/app/core/services/patients-admin/catalog-patients.service';
import { SexDto } from 'src/app/core/models/catalog/sex.dto';
import { StringUtilsHelper } from '../../helpers/strings.helper';
import { BiologicalSexDto } from 'src/app/core/models/catalog/biological-sex.dto';
import { Subscription } from 'rxjs';
import { WorkplaceStorageService } from 'src/app/core/services/local/workplaces-storage.service';
import { AllergiesPatientService } from 'src/app/core/services/patients-admin/core/services/patients-admin/allergies-patient.service';
import { AllergyStatusService } from 'src/app/core/services/patients-admin/core/services/patients-admin/AllergyStatusService.service';
import { Router } from '@angular/router';
import { NavigationHelper } from '../../helpers/navigation.helper';
import { DefaultConfigComponent } from '../../inherit/default-config.component';
import { PatientViewModel } from './patient-view.model';
import { SnackbarService } from '../snackbar/snackbar.service';
import { InfoHelper } from '../../helpers/info.helper';
import { SendInfoComponentService } from 'src/app/core/services/local/send-info.component.service';
import { NavStorageService } from 'src/app/core/nav-storage/services/nav-storage.service';

@Component({
	selector: 'app-patient-sidenav',
	templateUrl: './patient-sidenav.component.html',
	styleUrls: ['./patient-sidenav.component.scss'],
})
export class PatientSidenavComponent extends DefaultConfigComponent<PatientViewModel> implements OnInit, OnChanges {
	@Input() patientObj?: PatientDto;
	sexObj$;
	hasImage: boolean = false;
	classTypeBase: string = 'user-avatar rounded-circle border border-5 border-';
	priorityTypeBase: string = 'user-avatar-priority bg-';
	classType: string = '';
	priorityType: string = '';
	priority: string = '';
	triageType: number = 0;
	allergyStatus: 'none' | 'medication' | 'other' | 'no-allergies' = 'none';
	allergyTooltip: string = 'No se han registrado alergias';
	private patientRecordId: string = '';

	private allergyStatusSubscription: Subscription;

	constructor(
		public dialog: MatDialog,
		catalogService: CatalogPatientService,
		private allergiesService: AllergiesPatientService,
		private allergyStatusService: AllergyStatusService,
		readonly nav: Router,
		snackBar: SnackbarService, info: InfoHelper, navStorage: NavStorageService, send: SendInfoComponentService
	) {
		super(snackBar, info, navStorage, nav, NavigationHelper.createTab("patient-info", "patient-info"), send);
		this.sexObj$ = catalogService.getBiologicalSexes();
	}

	ngOnInit(): void {
		this.initSessionState();
		this.loadInfoPatient();
	}

	ngOnDestroy(): void {
		if (this.allergyStatusSubscription) {
			this.allergyStatusSubscription.unsubscribe();
		}
		this.beforeCloseSessionState();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes['patientObj']){
			this.getViewState();
			this.loadInfoPatient();
		}
	}

	private loadInfoPatient(){
		this.hasImage = StringUtilsHelper.notNullOrUndefinedOrEmpty(this.patientObj?.data?.imageB64Id);
		this.triageType = this.patientObj.triage.priorityId;
		this.getUserclass(this.patientObj.triage.priorityId, this.patientObj.triage.triageType);
		this.priority = this.patientObj.triage.priority;
		this.loadPatientId(); // Carga el ID del paciente
		if (this.patientRecordId) {
			this.loadAllergiesStatus(); // Carga las alergias si el ID está disponible
		} else {
			this.allergyStatusService.updateAllergyStatus({
				status: 'none',
				tooltip: 'Error: ID del paciente no encontrado'
			});
		}

		this.allergyStatusSubscription = this.allergyStatusService.allergyStatus$.subscribe((status) => {
			this.allergyStatus = status.status;
			this.allergyTooltip = status.tooltip;
		});
	}

	private loadPatientId(): void {
		try {
			const patientId = WorkplaceStorageService.getPatientIdMenu();
			if (patientId) {
				this.patientRecordId = patientId;
				
			} else {
				throw new Error('Patient ID not found');
			}
		} catch (error) {
			console.error('Error loading patient ID:', error);
		}
	}


	showDialogInfoPatient() {
		this.dialog.open(DialogPatientSummarySheet, {
			width: '96%',
			maxWidth: '60rem',
			maxHeight: '90vh',
			data: { patientObj: this.patientObj, urlBase: NavigationHelper.getUrlComponent(this.nav.url, true) }
		});
	}

	getSexStr(obj: SexDto[]) {
		if (StringUtilsHelper.notNullOrUndefinedOrEmpty(obj)) {
			let sex = StringUtilsHelper.findByIdForList<BiologicalSexDto>(obj, "id", this.patientObj?.data?.biologicalSexId);
			this.patientObj.data.biologicalSexName = sex.biologicalSex;
		}
	}

	getUserclass(priorityId: number, priorityType: string) {
		let priotityClass = '';
		if(priorityType === 'G') {
			switch (priorityId) {
			case 1:
				priotityClass = 'danger';
				break;
			case 2:
				priotityClass = 'warning';
				break;
			case 3:
				priotityClass = 'caution';
				break;
			case 4:
				priotityClass = 'success';
				break;
			case 5:
				priotityClass = 'info';
				break;
			default:
				priotityClass = 'alternative';
				break;
			}
		} else if(priorityType === 'O') {
			switch (priorityId) {
			case 1:
				priotityClass = 'danger';
				break;
			case 2:
				priotityClass = 'caution';
				break;
			case 3:
				priotityClass = 'success';
				break;
			default:
				priotityClass = 'alternative';
				break;
			}
		}
		this.classType = this.classTypeBase.concat(priotityClass);
		this.priorityType = this.priorityTypeBase.concat(priotityClass);
	}

	loadAllergiesStatus() {
		if (this.patientObj) {
			this.allergiesService.getAllergiesByPatientId(true).subscribe(
				(allergies) => {
					let status: 'none' | 'medication' | 'other' | 'no-allergies' = 'none';
					let tooltip = 'Alergias registradas';  // Tooltip siempre fijo
					if (!allergies || allergies.length === 1) {
						this.allergyStatusService.updateAllergyStatus({ status, tooltip });
						return;
					}

					const noAllergiesRecord = allergies.find(allergy =>
						allergy.allergyDesc === 'Alergias negadas' ||
						allergy.allergyDesc === 'ALERGIAS NEGADAS'
					);

					if (noAllergiesRecord) {
						status = 'no-allergies';
						tooltip = 'Alergias negadas';
						this.allergyStatusService.updateAllergyStatus({ status, tooltip });
						return;
					}

					const activeAllergies = allergies.filter(allergy => allergy.status === 2); // Solo alergias activas

					if (activeAllergies.length === 1) {
						this.allergyStatusService.updateAllergyStatus({ status: 'none', tooltip: 'No tiene alergias activas' });
						return;
					}

					// Buscar alergias de mayor severidad (Medicamentos > Alimentos > Animales > Otros)
					const medicationAllergy = activeAllergies.find(allergy =>
						allergy.allergieType?.allergieTypeKey === 'MEDICAMENTOS'
					);

					if (medicationAllergy) {
						status = 'medication';
						tooltip = 'Alergias registradas';  // Tooltip fijo para medicamentos
						this.allergyStatusService.updateAllergyStatus({ status, tooltip });
						return;
					}

					const foodAllergy = activeAllergies.find(allergy =>
						allergy.allergieType?.allergieTypeKey === 'ALIMENTOS'
					);

					if (foodAllergy) {
						status = 'other';
						tooltip = 'Alergias registradas';  // Tooltip fijo para alimentos
						this.allergyStatusService.updateAllergyStatus({ status, tooltip });
						return;
					}

					const animalAllergy = activeAllergies.find(allergy =>
						allergy.allergieType?.allergieTypeKey === 'ANIMALES'
					);

					if (animalAllergy) {
						status = 'other';
						tooltip = 'Alergias registradas';  // Tooltip fijo para animales
						this.allergyStatusService.updateAllergyStatus({ status, tooltip });
						return;
					}

					const otherAllergy = activeAllergies.find(allergy =>
						allergy.allergieType?.allergieTypeKey === 'OTROS'
					);

					if (otherAllergy) {
						status = 'other';
						tooltip = 'Alergias registradas';  // Tooltip fijo para otras alergias
					}

					this.allergyStatusService.updateAllergyStatus({ status, tooltip });
				}
			);
		}
	}

	getAllergyIconColor(status: 'none' | 'medication' | 'other' | 'no-allergies'): string {
		if (status === 'none') {
		return 'none';  // Sin color
		}

		if (status === 'no-allergies') {
		return 'primary';  // Azul
		}

		if (status === 'medication') {
		return 'warn';  // Naranja (Medicamento)
		}

		return 'accent';  // Amarillo (Otros)
	}

	getAge(bDate : Date){
		let age = StringUtilsHelper.getAgeExactNumber(bDate);
		return age.years;
	}

	/**
	   * Funciones override para controlar el estado de la pantalla con sus datos
	   * 
	   */

	override getViewState() {
		this.me.patient = this.getFormControl();
	}
	override setViewState() {
		this.setFormControl(this.me.patient);
	}

	// CONTROL DE FORMULARIOS seters y geters
	override newState(me: PatientViewModel): PatientViewModel {
		me.patient = this.getFormControl();
		return me;
	}
	override getFormControl() {
		return WorkplaceStorageService.getPatientData();
	}
	override setFormControl(patient: PatientViewModel) {		
		this.patientObj = patient.patient;
	}


}
